/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is my text uploaded?`)
};

const es_ci_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Se carga mi texto?`)
};

const de_ci_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird mein Text hochgeladen?`)
};

const nl_ci_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wordt mijn tekst geüpload?`)
};

const fr_ci_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon texte est-il téléchargé ?`)
};

const it_ci_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il mio testo viene caricato?`)
};

const pt_br2_ci_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meu texto é carregado?`)
};

const pt_ci_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O meu texto é carregado?`)
};

const ja_ci_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「テキストはアップロードされますか?」`)
};

const zh_ci_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的文本会被上传吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_faq3_q", locale)
	if (locale === "en") return en_ci_faq3_q(inputs)
	if (locale === "es") return es_ci_faq3_q(inputs)
	if (locale === "de") return de_ci_faq3_q(inputs)
	if (locale === "nl") return nl_ci_faq3_q(inputs)
	if (locale === "fr") return fr_ci_faq3_q(inputs)
	if (locale === "it") return it_ci_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_ci_faq3_q(inputs)
	if (locale === "pt") return pt_ci_faq3_q(inputs)
	if (locale === "ja") return ja_ci_faq3_q(inputs)
	return zh_ci_faq3_q(inputs)
};